import { Colors } from '@/common/colors/colors';
import AreYouSure from '@/common/components/areYouSure/AreYouSure';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import useCandidateForm from '../hooks/useCandidateForm';
import { ButtonWrapper, GridForm, Title } from '../styles/Recruitment.styled';
import ActionButtons from './ActionButtons';
import FormInputs from './FormInputs';
import Logs from './Logs';
import AcceptPopUp from './popUps/AcceptPopUp';
import DocsPopUp from './popUps/DocsPopUp';
import InstructionsPopUp from './popUps/InstructionsPopUp';

const CandidateForm = (props) => {
	const hook = useCandidateForm(props);

	return (
		<>
			<PopUp padding='10px 20px 15px' setShow={hook.setShow}>
				{hook.isLoading && <Loading />}

				<GridForm onSubmit={hook.formik.handleSubmit}>
					<div ref={hook.inputsRef}>
						<Title>
							{hook.selectedCandidate?._id ? 'Edit candidate' : 'Add candidate'}
						</Title>

						<FormInputs hook={hook} />
					</div>

					<Logs data={hook.getLogs()} />

					<ButtonWrapper>
						{hook.showAllButtons && <ActionButtons hook={hook} />}
						{hook.showSubmitButton && (
							<SubmitButton text='Save' color={Colors.darkBlue} />
						)}
					</ButtonWrapper>
				</GridForm>
			</PopUp>
			{hook.showAccept && (
				<AcceptPopUp
					setShow={hook.setShowAccept}
					handleSubmit={hook.handleAccept}
				/>
			)}
			{hook.showInstructions && (
				<InstructionsPopUp
					setShow={hook.setShowInstructions}
					handleSubmit={hook.handleInstructions}
				/>
			)}
			{hook.showDocs && (
				<DocsPopUp setShow={hook.setShowDocs} handleSubmit={hook.handleDocs} />
			)}
			{hook.showAreYouSure && (
				<AreYouSure next={hook.handleReject} setShow={hook.setShowAreYouSure} />
			)}
		</>
	);
};

export default CandidateForm;
